import { StatusEffectEntity } from 'genopets-utils';
import { MenuStatusItem } from './MenuStatusItem';

export const MenuStatus = ({ status }: { status?: StatusEffectEntity[] }) => {
  return status?.map((s, i) => {
    return <MenuStatusItem key={i} status={s} />;
  });
};
